
export default class LoadingCircle {

    constructor() {
        this.previousText = ""
    }

    buttonShow(element) {
        element.attr('disabled', true)
        this.previousText = element.html()
        element.html('<svg class="circular"><circle class="path" cx="10" cy="10" r="8" fill="none" stroke-width="2" stroke-miterlimit="10" /></svg> PLEASE WAIT...')
    }

    buttonHide(element) {
        element.attr('disabled', false)
        element.html(this.previousText)
    }

    buttonDisabled(element) {
        element.attr('disabled', true)
        element.html(this.previousText)
        element.find('i').remove();
    }

    modalShow(element) {
        if(element){
            element.insertAdjacentHTML('beforebegin', `
                <div class="loading-icon" class="d-none">
                    <?xml version="1.0" encoding="utf-8"?>
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: none; display: block; shape-rendering: auto;" width="36px" height="36px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                        <circle cx="50" cy="50" fill="none" stroke="#032836" stroke-width="12" r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                        <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                        </circle>
                    </svg>
                </div>
            `)
        }
    }

    modalHide(element) {
        if(element.find(`.loading-icon`)) {
            element.find(`.loading-icon`).remove()
        }
    }
}
